import { status } from "skin/event/status";

function _multy(obj, data) {
	data.setValue("value", 1);
	return status.action;
}

function _value(multy) {
	if (!multy) return status.ignore
	return status.action;
}

export { _multy, _value };
